import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbCollapse, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonService } from '../../../Model/Common/common.service';
import { UserRightService } from '../../../Model/UserRight/user-right.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-tax-declaration-approval-detail',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, RouterModule, LoaderComponent, NgbCollapse],
  templateUrl: './tax-declaration-approval-detail.component.html',
  styleUrl: './tax-declaration-approval-detail.component.scss'
})
export class TaxDeclarationApprovalDetailComponent {
  isDisabled: boolean = false
  isSuper: boolean = false;//for super admin
  GetID = 0;//1-detail,2-request
  isApprovalLavel = true;
  OpenCard = {
    CardPreviousEmployment: true as any,
    CardEmpTaxDeclarationDetails: true as any,
    CardEmpTaxDeclarationDetails_HRA: true as any,
    CardEmpTaxDeclarationDetails_Others: true as any,
    CardEmpTaxDeclarationDetails_LOP: true as any,
    ESS_EmpTaxDeclarationDetails_TDS: true as any,
    ESS_EmpTaxDeclarationDetails_SOP: true as any,
  }
  DetailData = {
    WebESSApprovalRequestTrackingId: null as any,
    TransactionId: null as any,
    IsNewRegime: null,
    FinancialYearStart: null,
    FinancialYearEnd: null,
    RequestDate: null as any,
    EmpMasterId: null,
    EmpCode: null,
    Photo: null,
    EmployeeName: null as any,
    DesignationMasterId: null,
    DesignationName: null,
    BranchName: null,
    ClientLocation: null,
    EmpType: null as any,
    ApprovalStatus: null as any,
  };

  TablesData = {
    Table: [
      {
        ESS_EmpTaxDeclarationDetailsId: null,
        ESS_EmpTaxDeclarationID: null,
        ESS_TaxSectionMasterId: null,
        ESS_TaxSectionMasterId1: null,
        SectionCode: null,
        SectionName: null,
        IncomeHead: null,
        SectionDescription: null,
        SubSectionName: null,
        SubSectionDescription: null,
        IsNewMaxlimitapplicable: null,
        IsOldMaxlimitapplicable: null,
        NewRegimeMaxAmount: null,
        OldRegimeMaxAmount: null,
        DeclaredAmount: null,
        ApprovedAmount: null,
      }
    ],
    Table1: [
      {
        ESS_EmpTaxDeclarationDetails_HRAID: null,
        ESS_EmpTaxDeclarationID: null,
        FromDate: null,
        ToDate: null,
        NameOfLandlord: null,
        LandLordPanNo: null,
        Address: null,
        IsMetroCity: null,
        DeclaredAmount: null,
        ApprovedAmount: null,
      }
    ],
    Table2: [
      {
        ESS_TaxPreviousEmploymentDetailsID: null,
        ESS_EmpTaxDeclarationID: null,
        Monthname: null,
        Yearname: null,
        Remarks: null,
        Basic: null,
        DA: null,
        HRA: null,
        OtherAllowance: null,
        GrossAmount: null,
        PT: null,
        PF: null,
        TDS: null,
        OtherDeduction: null,
        NetAmount: null,
      }
    ],
    Table3: [
      {
        ESS_EmpTaxDeclarationDetails_OthersID: null,
        ESS_EmpTaxDeclarationID: null,
        ESS_TaxSectionDetailId: null,
        SubSectionName: null,
        SubSectionDescription: null,
        IsOldMaxlimitapplicable: null,
        IsNewMaxlimitapplicable: null,
        OldRegimeMaxAmount: null,
        NewRegimeMaxAmount: null,
        DeclaredAmount: null,
        ApprovedAmount: null,
      }
    ],
    Table4: [
      {
        ESS_EmpTaxDeclarationDetails_LOPID: null,
        ESS_EmpTaxDeclarationID: null,
        AnnualRentReceived: null,
        NetAnnualValue: null,
        StandardDeduction: null,
        RepayingHomeLoanForThisProperty: null,
        PrincipalPaidOnHomeLoan: null,
        MunicipalTaxesPaid: null,
        InterestPaidOnHomeLoan: null,
        NameOfTheLender: null,
        LenderPanNo: null,
        NetIncomeLossFromHouseProperty: null,
      }
    ],
    Table5: [
      {
        ESS_EmpTaxDeclarationDetails_TDSID: null,
        ESS_EmpTaxDeclarationID: null,
        TDSorTCSPaid: null,
        ChallanNo: null,
        PaymentDate: null,
      }
    ],
    Table6: [
      {
        ESS_EmpTaxDeclarationDetails_SOPID: null,
        ESS_EmpTaxDeclarationID: null,
        AnnualInterestPaidORPayable: null,
        PrincipalRepaymentAmount: null,
        LenderName: null,
        LenderPANNo: null,
        PropertyAddress: null,
        PossessionDate: null,
        CoOwnedProperty: null,
        CoOwnerName: null,
        CoOwnerSharePerc: null,
      }
    ]
  };

  updateDate = { SelectType: 'U', ESS_EmpTaxDeclarationId: null, ESS_EmpTaxDeclarationDetailsAmt: [] as any, ESS_EmpTaxDeclarationDetails_HRAAmt: [] as any, ESS_EmpTaxDeclarationDetails_OthersAmt: [] as any };

  Trackings = [];
  TrackingsUser = [];
  user = [] as any;
  Filter = {
    ModuleMasterId: 9,
    WebESSApprovalRequestTrackingId: 0,
    FromDate: null,
    ToDate: null,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpMasterId: 0,
    EmpMappingId: 0,
    SelectType1: 'D',
    SelectType: null,
    EmpType: null,
    Remark: null,
    isShowError: false,
  }

  constructor(
    private approvalMatrix: ApprovalMatrixService,
    private route: ActivatedRoute,
    private session: SessionService,
    private toast: ToastService,
    private incometax: IncometaxService,
    private router: Router,
    protected common: CommonService,
    protected dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    protected tooltip: TooltipService,
    private userright: UserRightService
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.Filter.WebESSApprovalRequestTrackingId = parseInt(params['id']));
    if (window.location.pathname.includes('todo')) {
      this.GetID = 1;
    } else if (window.location.pathname.includes('request')) {
      this.GetID = 2
    }
  }

  ngOnInit(): void {
    if (this.user.UserType == 'E') {
      this.Filter.EmpMappingId = this.user.UserId;
    }
    if (this.GetID == 1) {
      this.ApprovalMatrixRequestGet();
      this.ESS_GetUserRole();
    } else if (this.GetID == 2) {
      this.ESS_EmpTaxDeclarationSelect('S');
    }
  }

  ApprovalMatrixRequestGet() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet(this.Filter).subscribe({
      next: (response) => {
        if (this.Filter.ModuleMasterId == 9) {
          if (response.Table.length > 0) {
            this.DetailData = response.Table[0];
          } else if (response.Table1.length > 0) {
            this.DetailData = response.Table1[0];
          } else if (response.Table2.length > 0) {
            this.DetailData = response.Table2[0];
          } else if (response.Table3.length > 0) {
            this.DetailData = response.Table3[0];
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
        this.ESS_EmpTaxDeclarationSelect('D');
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.DetailData.TransactionId }).subscribe({
      next: (response) => {
        if (response.Table.length == 0) {
          this.isApprovalLavel = false;
        }
        if (this.common.ToLowerCase(this.DetailData.ApprovalStatus) == 'pending') {
          if (this.user.UserType == 'A') {
            this.TrackingsUser = response.Table.filter((e: any) => e.ApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.ApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          } else if (this.user.UserType == 'E') {
            this.TrackingsUser = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.EmpApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          }
        } else {
          this.Trackings = response.Table.sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestProcess(SelectType: string) {
    //greter then check commit confirm with rahul
    // if (this.TablesData.Table.filter((e: any) => e.DeclaredAmount < e.ApprovedAmount).length > 0) {
    //   this.toast.show({ message: 'Not allow to add approve amount greater than declared amount. (Chapter VI A Details)', type: toastTypeEnum.warning });
    // } else 
    if (this.TablesData.Table.filter((e: any) => e.ApprovedAmount == null || e.ApprovedAmount == '' || e.ApprovedAmount < 0).length > 0) {
      this.toast.show({ message: 'Not allow to add approve amount in minus or blank.  (Chapter VI A Details)', type: toastTypeEnum.warning });
    }
    // else if (this.TablesData.Table1.filter((e: any) => e.DeclaredAmount < e.ApprovedAmount).length > 0) {
    //   this.toast.show({ message: 'Not allow to add approve amount greater than declared amount. (Are you staying in a rented house?)', type: toastTypeEnum.warning });
    // } 
    else if (this.TablesData.Table1.filter((e: any) => e.ApprovedAmount == null || e.ApprovedAmount == '' || e.ApprovedAmount < 0).length > 0) {
      this.toast.show({ message: 'Not allow to add approve amount in minus or blank.  (Are you staying in a rented house?)', type: toastTypeEnum.warning });
    }
    // else if (this.TablesData.Table3.filter((e: any) => e.DeclaredAmount < e.ApprovedAmount).length > 0) {
    //   this.toast.show({ message: 'Not allow to add approve amount greater than declared amount. (Other Sources of Income)', type: toastTypeEnum.warning });
    // } 
    else if (this.TablesData.Table3.filter((e: any) => e.ApprovedAmount == null || e.ApprovedAmount == '' || e.ApprovedAmount < 0).length > 0) {
      this.toast.show({ message: 'Not allow to add approve amount in minus or blank.  (Other Sources of Income)', type: toastTypeEnum.warning });
    } else {
      if (((SelectType == 'Reject' && this.Filter.Remark != '' && this.Filter.Remark != null) || SelectType == 'Approve') || this.isSuper) {
        const modalRef = this.modalService.open(ConfirmationComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = 'Do you want to ' + SelectType + '?';
        modalRef.result.then((result: any) => {
          if (result) {
            this.isDisabled = true;

            if (this.TablesData.Table.filter((e: any) => e.DeclaredAmount != e.ApprovedAmount).length > 0 ||
              this.TablesData.Table1.filter((e: any) => e.DeclaredAmount != e.ApprovedAmount).length > 0 ||
              this.TablesData.Table3.filter((e: any) => e.DeclaredAmount != e.ApprovedAmount).length > 0) {

              this.updateDate.ESS_EmpTaxDeclarationId = this.DetailData.TransactionId;
              this.updateDate.ESS_EmpTaxDeclarationDetailsAmt = [];
              this.updateDate.ESS_EmpTaxDeclarationDetails_HRAAmt = [];
              this.updateDate.ESS_EmpTaxDeclarationDetails_OthersAmt = [];

              this.TablesData.Table.forEach(element => {
                this.updateDate.ESS_EmpTaxDeclarationDetailsAmt.push(
                  {
                    ESS_EmpTaxDeclarationDetailsID: element.ESS_EmpTaxDeclarationDetailsId,
                    ApprovedAmount: element.ApprovedAmount,
                  }
                );
              });

              this.TablesData.Table1.forEach(element => {
                this.updateDate.ESS_EmpTaxDeclarationDetails_HRAAmt.push(
                  {
                    ESS_EmpTaxDeclarationDetails_HRAID: element.ESS_EmpTaxDeclarationDetails_HRAID,
                    ApprovedAmount: element.ApprovedAmount,
                  }
                );
              });

              this.TablesData.Table3.forEach(element => {
                this.updateDate.ESS_EmpTaxDeclarationDetails_OthersAmt.push(
                  {
                    ESS_EmpTaxDeclarationDetails_OthersID: element.ESS_EmpTaxDeclarationDetails_OthersID,
                    ApprovedAmount: element.ApprovedAmount,
                  }
                );
              });

              this.incometax.ESS_TaxDeclarationUpdateAtApproval(this.updateDate).subscribe({
                next: (response) => {
                  if (response.Error_Code == '694') {
                    this.RequestAR(SelectType);
                  } else {
                    const modalRef = this.modalService.open(AlertWarningComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => { });
                    this.isDisabled = false;
                  }
                },
                complete: () => { },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
            } else {
              this.RequestAR(SelectType);
            }
          }
        }).catch(() => { });
      } else {
        this.Filter.isShowError = true;
        this.toast.show({ message: 'Please enter remark', type: toastTypeEnum.warning });
      }
    }
  }

  RequestAR(SelectType: string) {
    this.isDisabled = true;
    //this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, approvedid: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
    this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
      next: (response) => {
        if (response.Error_Code == '49' || response.Error_Code == '50' || response.Error_Code == '51') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.router.navigate(['/todo/taxdeclaration/']);
            }
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Cancel() {
    if (this.GetID == 1) {
      if (this.user.UserType == 'A') {
        this.router.navigate(['/todo/taxdeclaration/']);
      } else if (this.user.UserType == 'E') {
        this.router.navigate(['/request/taxdeclaration/approval/']);
      }
    } else if (this.GetID == 2) {
      this.router.navigate(['/request/taxdeclaration/']);
    }
  }

  ESS_GetUserRole() {
    this.isDisabled = true;
    try {
      this.userright.ESS_GetUserRole({ SelectType: 'S', EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
        next: (response) => {
          if (this.common.ToLowerCase(response.Table[0].UserRole) == 'superadmin') {
            this.isSuper = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } catch (e) {
      this.isDisabled = false;
    }
  }

  ESS_EmpTaxDeclarationSelect(selecttype: String) {
    this.isDisabled = true;
    this.incometax.ESS_EmpTaxDeclarationSelect({ SelectType: selecttype, ESS_EmpTaxDeclarationID: this.DetailData.TransactionId, EmpMasterId: selecttype == 'D' ? this.Filter.EmpMasterId : this.user.UserId, FinancialYearFrom: '', FinancialYearTo: '' }).subscribe({
      next: (response) => {
        if (response) {
          this.TablesData = response;
        }
        this.isDisabled = false;
      },
      complete: () => {
        if (selecttype == 'S') {
          this.ApprovalMatrixRequestGetTracking();
        }
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  onSwitchChange(event: any, cardname: string) {
    if (cardname == "CardPreviousEmployment") {
      this.OpenCard.CardPreviousEmployment = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails") {
      this.OpenCard.CardEmpTaxDeclarationDetails = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails_HRA") {
      this.OpenCard.CardEmpTaxDeclarationDetails_HRA = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails_Others") {
      this.OpenCard.CardEmpTaxDeclarationDetails_Others = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails_LOP") {
      this.OpenCard.CardEmpTaxDeclarationDetails_LOP = event.target.checked;
    } else if (cardname == "ESS_EmpTaxDeclarationDetails_TDS") {
      this.OpenCard.ESS_EmpTaxDeclarationDetails_TDS = event.target.checked;
    } else if (cardname == "ESS_EmpTaxDeclarationDetails_SOP") {
      this.OpenCard.ESS_EmpTaxDeclarationDetails_SOP = event.target.checked;
    }
  }

  removeError() {
    this.Filter.isShowError = false;
  }
}
